meedy.factory('meedy.termModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.termService', '$q',
    function ($rootScope, applicationModel, baseModel, termService, $q) {

        function TermModel() {
            this.getUpcomingTermsWithSkip = function (skipCount) {
                termService.getUpcomingTermsWithSkip(skipCount).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_UPCOMING_TERMS_WITH_SKIP.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_UPCOMING_TERMS_WITH_SKIP.ERROR, error);
                    }
                )
            };

            this.getUpcomingTerms = function () {
                termService.getUpcomingTerms().then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_UPCOMING_TERMS.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_UPCOMING_TERMS.ERROR, error);
                    }
                )
            };

            this.getTermDetails = function (idTerm) {
                termService.getTermDetails(idTerm).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_TERM_DETAILS.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_TERM_DETAILS.ERROR, error);
                    }
                )
            };

            this.getMonthlyCalendarData = function (startDate) {
                termService.getMonthlyCalendarData(startDate).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_MONTHLY_CALENDAR_DATA.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_MONTHLY_CALENDAR_DATA.ERROR, error);
                    }
                )
            };

            this.createNewInternalAppointment = function (term) {
                applicationModel.actionInProgress = true;
                termService.createNewInternalAppointment(term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CREATE_NEW_INTERNAL_APPOINTMENT.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CREATE_NEW_INTERNAL_APPOINTMENT.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.createTerm = function (term) {
                applicationModel.actionInProgress = true;
                termService.createTerm(term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CREATE_TERM.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CREATE_TERM.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.updateTerm = function (term) {
                applicationModel.actionInProgress = true;
                termService.updateTerm(term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_TERM.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_TERM.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.createNewPrivateTerm = function (term) {
                applicationModel.actionInProgress = true;
                termService.createNewPrivateTerm(term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CREATE_NEW_PRIVATE_TERM.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CREATE_NEW_PRIVATE_TERM.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.getCalendarData = function (startDate, calendarType, idResource) {
                termService.getCalendarData(startDate, calendarType, idResource).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_CALENDAR_DATA.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_CALENDAR_DATA.ERROR, error);
                    }
                )
            };

            this.updateInternalTermData = function (term) {
                applicationModel.actionInProgress = true;
                termService.updateInternalTermData(term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_INTERNAL_TERM_DATA.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_INTERNAL_TERM_DATA.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.updatePrivateTermData = function (term) {
                applicationModel.actionInProgress = true;
                termService.updatePrivateTermData(term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_PRIVATE_TERM_DATA.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_PRIVATE_TERM_DATA.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.cancelAppointment = function (termId, statusReasonId, statusDescription) {
                applicationModel.actionInProgress = true;
                termService.cancelAppointment(termId, statusReasonId, statusDescription).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CANCEL_APPOINTMENT.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CANCEL_APPOINTMENT.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.deleteTerm = function (idTerm) {
                applicationModel.actionInProgress = true;
                termService.deleteTerm(idTerm).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.DELETE_TERM.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.DELETE_TERM.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.getStatusReasons = function () {
                termService.getStatusReasons().then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_STATUS_REASONS.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_STATUS_REASONS.ERROR, error);
                    }
                )
            };

            this.verifyAppointment = function (termId, verificationCode) {
                termService.verifyAppointment(termId, verificationCode).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.VERIFY_APPOINTMENT.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.VERIFY_APPOINTMENT.ERROR, error);
                    }
                )
            };

            this.getAppointmentBillings = function (idTerm) {
                termService.getAppointmentBillings(idTerm).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_APPOINTMENT_BILLINGS.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_APPOINTMENT_BILLINGS.ERROR, error);
                    }
                )
            };

            this.executeAppointmentBillings = function (idTerm, dataWrapper) {
                termService.executeAppointmentBillings(idTerm, dataWrapper).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.EXECUTE_APPOINTMENT_BILLINGS.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.EXECUTE_APPOINTMENT_BILLINGS.ERROR, error);
                    }
                )
            };

            this.executeAppointment = function (termId, updateAppointmentWrapper) {
                applicationModel.actionInProgress = true;
                termService.executeAppointment(termId, updateAppointmentWrapper).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.EXECUTE_APPOINTMENT.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.EXECUTE_APPOINTMENT.ERROR, error);
                        applicationModel.actionInProgress = false
                    }
                )
            };

            this.beginAppointment = function (termId) {
                applicationModel.actionInProgress = true;
                termService.beginAppointment(termId).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.BEGIN_APPOINTMENT.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        baseModel.broadcastOperationFailed();
                        $rootScope.$broadcast(Event.MEEDY.TERM.BEGIN_APPOINTMENT.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.checkConflicts = function (term) {
                applicationModel.actionInProgress = true;
                termService.checkConflicts(term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.CHECK_CONFLICTS.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        //Workaround do czasu aż backend będzie zwracał error code.
                        $rootScope.$broadcast(Event.MEEDY.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.COLLISION_DETECTED'));
                        $rootScope.$broadcast(Event.MEEDY.TERM.CHECK_CONFLICTS.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.updateCyclicTerm = function (mode, term) {
                applicationModel.actionInProgress = true;
                termService.updateCyclicTerm(mode, term).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_CYCLIC_TERM.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.UPDATE_CYCLIC_TERM.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.deleteCyclicTerm = function (mode, idTerm) {
                applicationModel.actionInProgress = true;
                termService.deleteCyclicTerm(mode, idTerm).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.DELETE_CYCLIC_TERM.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.DELETE_CYCLIC_TERM.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.begin = function (idTerm) {
                applicationModel.actionInProgress = true;
                termService.begin(idTerm).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.BEGIN.SUCCESS, data);
                        applicationModel.actionInProgress = false;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.BEGIN.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };

            this.edmVisit = function (idTerm) {
                termService.edmVisit(idTerm).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.EDM_VISIT.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.EDM_VISIT.ERROR, error);
                    }
                )
            };

            this.getAttachments = function (idTerm) {
                termService.getAttachments(idTerm).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_ATTACHMENTS.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.GET_ATTACHMENTS.ERROR, error);
                    }
                )
            };

            this.downloadAttachment = function (idTerm, idAttachment, name) {
                termService.downloadAttachment(idTerm, idAttachment, name).then(
                    function (data) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.DOWNLOAD_ATTACHMENT.SUCCESS, data);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.TERM.DOWNLOAD_ATTACHMENT.ERROR, error);
                    }
                )
            };

            this.verifyAppointment = function (verification) {
                return termService.verifyAppointment(verification).then(
                    function (data) {
                        return data;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };

                this.getTakenTerms = function (criteria) {
                return termService.getTakenTerms(criteria).then(
                    function (data) {
                        return data;
                    },
                    function (error) {
                        return $q.reject(error);
                    }
                )
            };
        }

        return new TermModel();
    }
]);
